import React from 'react';

import { Grid, Section } from '@gogame/components';

export const CampaignsLinksSection = ({ buttons, links }) => {
  return (
    <Section data-cy-label={'Campaigns Links'} title={'Campaigns Links'}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {buttons}
        </Grid>
        <Grid item container xs={12}>
          {links}
        </Grid>
      </Grid>
    </Section>
  );
};
